import { IScene } from '@/interface';
import { transformObjectDeep } from '@/utils/tans/object';

import { apiPathServer } from './api-config';
import { CgiResp } from './cgi';
import { API_PREFIX, request } from './request';

/**
 * 保存项目信息
 */
export const getDiffList = async (storyId: string) => {
  const res = await request(`${API_PREFIX}${apiPathServer.getDiffList}`, {
    query: {
      id: storyId,
    },
  });
  return transformObjectDeep(res, 'camel') as CgiResp<{
    storyName: string,
    playerInfo: {
      name: string,
    }
    chapterList: {
      chapterId: string,
      name: string
      sceneList: {
        name: string,
        sceneId: string
      }[]
    }[]
  }>;
};

export const getSceneDiffDetail = async (storyId: string) => {
  const res = await request(`${API_PREFIX}${apiPathServer.getSceneDiffDetail}`, {
    query: {
      id: storyId,
    },
  });
  return transformObjectDeep(res, 'camel') as CgiResp<{
    sceneId: string,
    releaseData: IScene,
    draftData: IScene
  }>;
};

